import { Navigate } from "react-router-dom";
import { SignIn } from "@clerk/clerk-react";
import { LoadingSpinner } from "@/components/auth/LoadingSpinner";
import { getRuntimeAuthProvider } from "@/config/auth";
import { useProviderAuth } from "@/hooks/useProviderAuth";
import { Button } from "@/components/ui/button";

export default function Login() {
  const auth = useProviderAuth();
  const provider = getRuntimeAuthProvider();

  // Show loading indicator if we're still checking authentication status
  if (!auth.isLoaded) {
    return <LoadingSpinner />;
  }

  // Redirect if authentication is confirmed
  if (auth.isSignedIn && auth.user) {
    return <Navigate to="/dashboard" replace />;
  }

  if (provider === "auth0") {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 gap-6">
        <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-md border border-gray-100 flex flex-col items-center gap-6">
          <div className="flex items-center gap-2">
            <img 
              src="https://v1.calone.com/static/graphics/CalOne_31_Logo.png" 
              alt="CalOne Logo" 
              className="h-8 w-8"
            />
            <span className="text-2xl font-bold text-[#669933]">CalOne Events</span>
          </div>
          <p className="text-gray-600 text-center text-sm">
            Sign in with Auth0 to access your events
          </p>
          <Button onClick={() => auth.signIn("/dashboard")} className="w-full bg-[#669933] hover:bg-[#55822b] text-white">
            Sign in with Auth0
          </Button>
        </div>
        <button 
          onClick={() => {
            localStorage.setItem("active_auth_provider", "clerk");
            window.location.reload();
          }} 
          className="text-sm text-gray-500 hover:text-gray-800 underline transition-colors"
        >
          Sign in with Clerk instead
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 gap-6">
      <SignIn
        appearance={{
          elements: {
            card: "shadow-md border border-gray-100 bg-white rounded-xl",
            formButtonPrimary: "bg-[#669933] hover:bg-[#55822b]",
          },
        }}
        afterSignInUrl="/dashboard"
        signUpUrl="/register"
      />
      <button 
        onClick={() => {
          localStorage.setItem("active_auth_provider", "auth0");
          window.location.reload();
        }} 
        className="text-sm text-gray-500 hover:text-gray-800 underline transition-colors"
      >
        Sign in with Auth0 instead
      </button>
    </div>
  );
}
